import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ToolTipComponent from '../../components/GlobalComponents/ToolTipComponent';

const CopyIconButtonWithTooltip = ({ title, onClick, disabled }) => (
    <ToolTipComponent title={title} arrow>
        <IconButton
            onClick={onClick}
            sx={{ marginTop: 3, mb: 'auto', position: 'relative' }}
            disabled={disabled}
        >
            <ContentCopyIcon />
            <ArrowRightAltIcon sx={{ position: 'absolute', fontSize: 18, right: -8, top: 12 }} />
        </IconButton>
    </ToolTipComponent>
);

export default CopyIconButtonWithTooltip;
